function getLicenseRequired(licenceRequired) {
  return licenceRequired ? 'Yes' : 'No';
}

function splitStringOnCaptitals(text) {
  return text.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
}

function getTransportModes(transportModes) {
  if (
    !transportModes ||
    transportModes.length === 0 ||
    (transportModes.length === 1 &&
      transportModes.find((mode) => mode.type === 'NotIncluded'))
  ) {
    return 'Walking';
  }
  return transportModes
    .map(({ type }) => splitStringOnCaptitals(type))
    .join(', ');
}

function getExpertise(expertise) {
  if (!expertise || expertise.length === 0) {
    return 'Not Applicable';
  }
  return expertise.map(({ type }) => splitStringOnCaptitals(type)).join(', ');
}

export default {
  getLicenseRequired,
  getTransportModes,
  getExpertise,
};
